// FlixDetailJsonLd.js
import { connect } from 'react-redux';

import FlixDetailJsonLd from '../component/FlixDetailJsonLd.jsx';

import getMessageData from '../selector/getMessageData.js';
import getUserData from '../selector/getUserData.js';
import getMessageDuration from '../selector/getMessageDuration.js';
import getListData from '../selector/getListData.js';

const mapStateToProps = (state, { messageId }) => {
  const senderId = getMessageData(state, messageId, 'senderId');
  const selectPath = ['home', 'messages', `message-${messageId}`]; // related message
  const relatedMessageIds = getListData(state, selectPath, 'itemIds');

  return {
    senderId,
    senderName: getUserData(state, senderId, 'username'),
    title: getMessageData(state, messageId, 'title'),
    description: getMessageData(state, messageId, 'description'),
    postedAtUnix: getMessageData(state, messageId, 'postedAtUnix'),
    durationSecs: getMessageDuration(state, messageId),
    viewCount: getMessageData(state, messageId, 'views'),
    unlockCount: getMessageData(state, messageId, 'unlocks'),
    likeCount: getMessageData(state, messageId, 'likes'),
    dislikeCount: getMessageData(state, messageId, 'dislikes'),
    relatedMessageIds,
    assetIds: getMessageData(state, messageId, 'assetIds'),
  };
};

export default connect(mapStateToProps)(FlixDetailJsonLd);
